import { FormattedMessage } from 'components/shared/Intl';
import type { SearchResultProps } from 'components/shared/SelectSearch/SelectSearch';
import type { Custodian } from 'models/custodian';
import { FC } from 'react';
import styled from 'styled-components';

import { CustodianSearchResultItem } from './CustodianResultItem';

export const StyledDiv = styled.div`
  max-height: 16rem;
`;
export const CustodianResult: FC<SearchResultProps<Custodian>> = ({
  data,
  onSelected,
  currentIndex,
  searchedText,
  getError,
}) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <StyledDiv className="overflow-y-auto border-top mt-2">
      <table className="table table-hover table-sm" data-e2e="custodians-search-items">
        <thead>
          <tr>
            <th>
              <FormattedMessage id="client.name" />
            </th>
            <th className="w-25">
              <FormattedMessage id="client.bdrId" />
            </th>
            <th>
              <FormattedMessage id="client.eliotCode" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => {
            return (
              <CustodianSearchResultItem
                key={item.id}
                item={item}
                onSelected={onSelected}
                isSelected={idx === currentIndex}
                searchedText={searchedText}
                getError={getError}
              />
            );
          })}
        </tbody>
      </table>
    </StyledDiv>
  );
};
CustodianResult.displayName = 'CustodianResult';
